<template>
  <b-modal
    id="edit-responsible-modal"
    ref="editResponsibleModalRef"
    size="lg"
    title="Editar Responsáveis"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          style="width: 100%;"
          label="Nome Resp. Cad."
          label-for="responsibleNameRegistration-input"
          invalid-feedback="Nome do responsável pelo cadastro é obrigatório"
        >
          <b-form-input
            id="responsibleNameRegistration-input"
            v-model="responsibleForm.responsibleNameRegistration"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="CPF/CNPJ Resp. Cad."
          style="width: 100%;"
          label-for="responsibleSocialNumberRegistration-input"
          invalid-feedback="CPF/CNPJ do responsável pelo cadastro é obrigatório"
        >
          <b-form-input
            id="responsibleSocialNumberRegistration-input"
            v-model="responsibleForm.responsibleSocialNumberRegistration"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          label="Tel. Resp. Cad."
          style="width: 100%;"
          label-for="responsiblePhoneRegistration-input"
          invalid-feedback="Telefone do responsável pelo cadastro é obrigatório"
        >
          <b-form-input
            id="responsiblePhoneRegistration-input"
            v-model="responsibleForm.responsiblePhoneRegistration"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Email Resp. Cad."
          style="width: 100%;"
          label-for="responsibleEmailRegistration-input"
          invalid-feedback="Email do responsável pelo cadastro é obrigatório"
        >
          <b-form-input
            id="responsibleEmailRegistration-input"
            v-model="responsibleForm.responsibleEmailRegistration"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group
        label="Relação Cad."
        label-for="responsibleLinkRegistration-input"
        invalid-feedback="Relação do responsável pelo cadastro é obrigatória"
      >
        <b-form-input
          id="responsibleLinkRegistration-input"
          v-model="responsibleForm.responsibleLinkRegistration"
          required
        ></b-form-input>
      </b-form-group>

      <hr />

      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          label="Nome Resp. Fin."
          style="width: 100%;"
          label-for="responsibleNameFinancial-input"
          invalid-feedback="Nome do responsável financeiro é obrigatório"
        >
          <b-form-input
            id="responsibleNameFinancial-input"
            v-model="responsibleForm.responsibleNameFinancial"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="CPF/CNPJ Resp. Fin."
          style="width: 100%;"
          label-for="responsibleSocialNumberFinancial-input"
          invalid-feedback="CPF/CNPJ do responsável financeiro é obrigatório"
        >
          <b-form-input
            id="responsibleSocialNumberFinancial-input"
            v-model="responsibleForm.responsibleSocialNumberFinancial"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <div style="display: flex; gap: 2rem; width: 100%;">
        <b-form-group
          label="Tel. Resp. Fin."
          style="width: 100%;"
          label-for="responsiblePhoneFinancial-input"
          invalid-feedback="Telefone do responsável financeiro é obrigatório"
        >
          <b-form-input
            id="responsiblePhoneFinancial-input"
            v-model="responsibleForm.responsiblePhoneFinancial"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Email Resp. Fin."
          style="width: 100%;"
          label-for="responsibleEmailFinancial-input"
          invalid-feedback="Email do responsável financeiro é obrigatório"
        >
          <b-form-input
            id="responsibleEmailFinancial-input"
            v-model="responsibleForm.responsibleEmailFinancial"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group
        label="Relação Fin."
        label-for="responsibleLinkFinancial-input"
        invalid-feedback="Relação do responsável financeiro é obrigatória"
      >
        <b-form-input
          id="responsibleLinkFinancial-input"
          v-model="responsibleForm.responsibleLinkFinancial"
          required
        ></b-form-input>
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
/// <reference path="../../common/types/index.js" />
import { Api } from '../../../vue/api';
const API = new Api();

export default {
  name: 'EditResponsibleModal',
  data() {
    return {
      /**
       * @type {ResponsibleForm}
       */
      responsibleForm: {
        id: '',
        responsibleNameRegistration: '',
        responsibleSocialNumberRegistration: '',
        responsiblePhoneRegistration: '',
        responsibleEmailRegistration: '',
        responsibleLinkRegistration: '',
        responsibleNameFinancial: '',
        responsibleSocialNumberFinancial: '',
        responsiblePhoneFinancial: '',
        responsibleEmailFinancial: '',
        responsibleLinkFinancial: '',
      },
    };
  },
  methods: {
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      await this.handleSubmit();
    },
    openModal(responsibleData) {
      this.responsibleForm = responsibleData;
      this.$refs.editResponsibleModalRef.show();
    },
    async handleSubmit() {
      for (const field of Object.values(this.responsibleForm)) {
        if (!field) {
          this.$bvToast.toast('Preencha todos os campos!', {
            title: `Erro`,
            variant: 'error',
            solid: true,
          });
          return;
        }
      }
      try {
        await API.post('/execute', {
          path: `/installation/responsible/edit`,
          method: 'post',
          data: this.responsibleForm,
        });
        this.$emit('getAll');
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } finally {
        this.$refs.editResponsibleModalRef.hide('edit-responsible-modal');
      }
    },
  },
};
</script>

<style scoped>
hr {
  margin: 1.5rem 0;
  border: 0;
  border-top: 1px solid #dee2e6;
}
</style>
